export default {
    props: {
        text: {
            type: String,
            required: true
        },
        author: {
            type: String,
            required: false
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/BlockQuote/BlockQuote.js